module.exports = __webpack_public_path__ + "img/mt4logo1.60ee3721.svg";